// @ts-ignore
import { /*loader,*/ gql } from "graphql.macro";

const dashboard = gql`
  query dashboard($where: DashboardWhereUniqueInput!) {
    dashboard(where: $where)
      @rest(type: "Dashboard", path: "dashboard/{args.where.id}") {
      id
      title
      owner
      group
      permissionOwner
      permissionGroup
      permissionOther
      publicAvailable
      status
      widgets @type(name: "Widget") {
        id
        title
        type
        interval @type(name: "DateRange") {
          startDate
          endDate
        }

        panelId
        layout @type(name: "WidgetLayout") {
          x
          y
          width
          height
          minWidth
          maxWidth
          minHeight
          maxHeight
        }
      }
    }
  }
`;

export default dashboard;
